import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./GamePage.css";
import {
  FaHome,
  FaGamepad,
  FaHeadphonesAlt,
  FaTrophy,
  FaTrailer,
} from "react-icons/fa";

export default function GamePage() {
  const navigate = useNavigate();
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await fetch("https://api.backofficemain.com/list_video.php?type=1");
        const data = await res.json();

        const formatted = data.map((v) => {
          let youtubeId = "";
          const link = v.videoLink || "";
          const match = link.match(/(?:v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
          youtubeId = match ? match[1] : link;
          return { ...v, youtubeId };
        });

        setVideos(formatted);
      } catch (error) {
        console.error("Failed to fetch videos:", error);
      }
    };
    fetchVideos();
  }, []);

  const handleCardClick = (video) => {
    navigate("/viewvideo", { state: video });
  };

  return (
    <div className="container py-4">
      {/* Menu */}
      <div className="d-flex justify-content-around text-center mb-4 menu-row">
        <div className="menu-btn" onClick={() => navigate("/")}>
          <FaHome className="menu-icon" />
          <span>Lobby</span>
        </div>
        <div className="menu-btn active" onClick={() => navigate("/game")}>
          <FaGamepad className="menu-icon" />
          <span>Game</span>
        </div>
        <div className="menu-btn" onClick={() => navigate("/esport")}>
          <FaTrophy className="menu-icon" />
          <span>eSports</span>
        </div>
        <div className="menu-btn" onClick={() => navigate("/music")}>
          <FaHeadphonesAlt className="menu-icon" />
          <span>Music</span>
        </div>
        <div className="menu-btn" onClick={() => navigate("/fullPage")}>
          <FaTrailer className="menu-icon" />
          <span>All</span>
        </div>
      </div>

      <h2 className="text-danger fw-bold mb-3 text-center">Featured Videos</h2>
      <div className="row g-3 mb-5">
        {videos.slice(0, 2).map((video) => (
          <div key={video.id} className="col-md-6">
            <div
              className="card shadow-sm border-0 cursor-pointer"
              onClick={() => handleCardClick(video)}
              style={{ cursor: "pointer" }}
            >
              <img
                src={`https://img.youtube.com/vi/${video.youtubeId}/0.jpg`}
                className="card-img-top"
                alt="Game Video"
              />
              <div className="card-body text-center">
                <h6 className="fw-bold text-danger">{video.title}</h6>
              </div>
            </div>
          </div>
        ))}
      </div>

      <h2 className="text-danger fw-bold mb-3 text-center">Game Videos</h2>
      <div className="row g-4">
        {videos.slice(2).map((video) => (
          <div key={video.id} className="col-6 col-md-4 col-lg-3">
            <div
              className="card shadow-sm border-0 h-100 cursor-pointer"
              onClick={() => handleCardClick(video)}
              style={{ cursor: "pointer" }}
            >
              <img
                src={`https://img.youtube.com/vi/${video.youtubeId}/0.jpg`}
                className="card-img-top"
                alt="Game Video"
              />
              <div className="card-body text-center">
                <h6 className="text-danger small">{video.title}</h6>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
